import { I18nDictionaryLanguageKeysType } from '@affiliate-cabinet/i18n'
import { FlagNamesType } from '@affstore-ds/flags'

export const LANGUAGES_TO_FLAGS_MAP: Record<I18nDictionaryLanguageKeysType, FlagNamesType> = {
  en: 'gb',
  ru: 'ru',
  it: 'it',
  de: 'de',
  es: 'es',
  pt: 'pt',
  zh: 'cn',
  sv: 'se',
  th: 'th',
  id: 'id',
  vi: 'vn',
}
